<script setup>
import { 
  ref,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import HeaderProfile from "@/components/v2/header/HeaderProfile.vue";
import HeaderNav from "@/components/v2/header/HeaderNav.vue";
import NotificationPopup from "@/components/v2/popup/NotificationPopup.vue";
import moment from "moment";
import { onOpenCasino, onOpenSlotGame, onOpenCashIn, onOpenCashOut } from "./common";

useI18n();

// store 설정
const store = useStore();
store.dispatch("fetchLobbyList");
store.dispatch("fetchHotGameList");

const currentDateTime = ref("");

// 메서드 정의
const updateDateTime = () => {
  const now = new Date();
  currentDateTime.value = moment(now).format("YYYY-MM-DD HH:mm:ss");
};

// 라이프사이클 훅
let intervalId = null;

onBeforeMount(() => {
});

onMounted(() => {
  updateDateTime();
  intervalId = setInterval(updateDateTime, 1000);
});

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});
</script>

<template>
  <header class="header">
    <HeaderProfile />
    <HeaderNav />
  </header>

  <!-- Menu for mobile start -->
  <div class="mr_menu">
    <button type="button" class="mr_menu_close">
      <i class="bi bi-x-lg"></i>
    </button>
    <div class="logo"></div>
    <div class="mr_navmenu_not_using">
      <ul class="main-menu">
        <li class="menu-item">
          <a href="javascript:void(0)" @click="onOpenCasino()">
            {{ $t('header.casino') }}
          </a>
        </li>
        <li class="menu-item">
          <a href="javascript:void(0)" @click="onOpenSlotGame()">
            {{ $t('header.slotGame') }}
          </a>
        </li>
        <li class="menu-item" v-if="$store.state.settings.isSportsOn">
          <a href="javascript:void(0)" @click="onOpenSports()">
            {{ $t('header.liveSports') }}
          </a>
        </li>
        <li class="menu-item">
          <a href="javascript:void(0)" @click="onOpenCashIn($store)">
            {{ $t('header.cashIn') }}
          </a>
        </li>
        <li class="menu-item">
          <a href="javascript:void(0)" @click="onOpenCashOut($store)">
            {{ $t('header.cashOut') }}
          </a>
        </li>
      </ul>
    </div>
  </div>
  <!-- Menu for mobile end -->

  <NotificationPopup />
</template>

<style></style>